var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProtectStarActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#212831",
  d: "M12.476 7.464a.5.5 0 0 0-.952 0l-.534 1.645a.5.5 0 0 1-.476.346h-1.73a.5.5 0 0 0-.294.904l1.4 1.018a.5.5 0 0 1 .181.559l-.534 1.646a.5.5 0 0 0 .769.559l1.4-1.018a.5.5 0 0 1 .588 0l1.4 1.018a.5.5 0 0 0 .77-.56l-.535-1.645a.5.5 0 0 1 .181-.56l1.4-1.017a.5.5 0 0 0-.294-.904h-1.73a.5.5 0 0 1-.476-.346z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#212831",
  fillRule: "evenodd",
  d: "M12 23.018a1 1 0 0 1-.5-.13C3.35 18.198 3 12.798 3 12.568v-8.44a1 1 0 0 1 .75-1l8-2.09a.85.85 0 0 1 .5 0l8 2.09a1 1 0 0 1 .75 1v8.4c0 .27-.33 5.67-8.47 10.36a1 1 0 0 1-.53.13m-7-10.49s.35 4.32 7 8.33c6.63-4 7-8.33 7-8.38v-7.58l-7-1.83-7 1.83z",
  clipRule: "evenodd"
})));
export default SvgProtectStarActive;